import React from 'react';

interface MetodoCierre {
  label: string;
  ventas: number;
  contado: number;
  diferencia: number;
}

interface CierreItem {
  nombreProducto: string;
  nombrePresentacion?: string;
  cantidad: number;
  precioUnitario: number;
  subtotal: number;
}

interface TicketCierreCajaProps {
  fecha: string;
  vendedor?: string;
  metodos: MetodoCierre[];
  items: CierreItem[];
  totalVentas: number;
  totalContado: number;
  diferenciaTotal: number;
  cantidadVentas: number;
}

export const TicketCierreCaja: React.FC<TicketCierreCajaProps> = ({
  fecha,
  vendedor,
  metodos,
  items,
  totalVentas,
  totalContado,
  diferenciaTotal,
  cantidadVentas,
}) => {
  const formatMoney = (amount: number) => `$${amount.toLocaleString('es-CO')}`;

  const difLabel = diferenciaTotal === 0 ? 'CUADRE' : diferenciaTotal > 0 ? 'SOBRANTE' : 'FALTANTE';
  const difSign = diferenciaTotal > 0 ? '+' : '';

  return (
    <div id="ticket-cierre" className="hidden-print">
      <div className="thermal-ticket">
        {/* Encabezado */}
        <div className="ticket-header">
          <h1 className="ticket-title">CONFIFARMA AMIGA</h1>
          <p className="ticket-subtitle">Tu salud con confianza</p>
          <p className="ticket-info">NIT: 1152707214-8</p>
          <p className="ticket-info">Tel: 3193650538</p>
          <p className="ticket-info">Cra. 104A #103A - 24 B/Velez Apartadó Ant</p>
        </div>

        <div className="ticket-divider">================================</div>

        <div className="ticket-section">
          <p className="ticket-row">
            <span className="ticket-label">CIERRE DE CAJA</span>
          </p>
          <p className="ticket-row">
            <span className="ticket-label">FECHA/HORA:</span>
            <span className="ticket-value">{fecha}</span>
          </p>
          <p className="ticket-row">
            <span className="ticket-label">VENDEDOR:</span>
            <span className="ticket-value">{vendedor || 'N/A'}</span>
          </p>
          <p className="ticket-row">
            <span className="ticket-label">VENTAS:</span>
            <span className="ticket-value">{cantidadVentas}</span>
          </p>
        </div>

        <div className="ticket-divider">================================</div>

        {/* Lista de productos vendidos */}
        <div className="ticket-items">
          <div className="ticket-item-header">
            <span className="ticket-col-desc">PRODUCTO</span>
            <span className="ticket-col-qty">CANT</span>
            <span className="ticket-col-total">TOTAL</span>
          </div>
          {items.map((item, idx) => (
            <div key={idx} className="ticket-item">
              <div className="ticket-item-name">
                {item.nombreProducto}
                {item.nombrePresentacion && item.nombrePresentacion !== 'unidad' && (
                  <span className="ticket-item-pres"> ({item.nombrePresentacion})</span>
                )}
              </div>
              <div className="ticket-item-row">
                <span className="ticket-col-qty">{item.cantidad} x {formatMoney(item.precioUnitario)}</span>
                <span className="ticket-col-total">{formatMoney(item.subtotal)}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="ticket-divider">================================</div>

        {/* Detalle por método */}
        <div className="ticket-items">
          <div className="ticket-item-header">
            <span className="ticket-col-desc">METODO</span>
            <span className="ticket-col-qty">VENTAS</span>
            <span className="ticket-col-total">CONTADO</span>
          </div>
          {metodos.map((m, idx) => (
            <div key={idx} className="ticket-item">
              <div className="ticket-item-name">{m.label}</div>
              <div className="ticket-item-row">
                <span className="ticket-col-qty">{formatMoney(m.ventas)}</span>
                <span className="ticket-col-total">{formatMoney(m.contado)}</span>
              </div>
              {m.diferencia !== 0 && (
                <div className="ticket-item-row">
                  <span className="ticket-col-qty" style={{ fontSize: '8pt' }}>
                    {m.diferencia > 0 ? 'Sobrante:' : 'Faltante:'}
                  </span>
                  <span className="ticket-col-total" style={{ fontSize: '8pt', color: m.diferencia > 0 ? '#059669' : '#dc2626' }}>
                    {formatMoney(Math.abs(m.diferencia))}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="ticket-divider">================================</div>

        {/* Totales */}
        <div className="ticket-totals">
          <div className="ticket-row">
            <span className="ticket-label">TOTAL VENTAS:</span>
            <span className="ticket-value">{formatMoney(totalVentas)}</span>
          </div>
          <div className="ticket-row">
            <span className="ticket-label">TOTAL CONTADO:</span>
            <span className="ticket-value">{formatMoney(totalContado)}</span>
          </div>
          <div className="ticket-row ticket-total-row">
            <span className="ticket-label">{difLabel}:</span>
            <span className="ticket-value">{difSign}{formatMoney(Math.abs(diferenciaTotal))}</span>
          </div>
        </div>

        <div className="ticket-divider">================================</div>

        {/* Pie */}
        <div className="ticket-footer">
          <p>*** CIERRE DE CAJA ***</p>
          <p>ConfiFarma Amiga</p>
          <p className="ticket-small">Documento de control interno</p>
        </div>
      </div>
    </div>
  );
};
